import { generateMutations } from '../builder'

export default {
  ...generateMutations('getPeriods', 'periods'),
  ...generateMutations('savePeriod', 'period'),
  ...generateMutations('getPeriod', 'period'),
  ...generateMutations('deletePeriod'),
}
